import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {
  API_CREATE_USER,
  API_DELETE_USER,
  API_GET_ROLES,
  API_GET_USERS,
  API_UPDATE_USER,
} from "../../../shared/routes/private.routes";

const config = {
  name: "userManagement",
};

export const getUsersList: any = createAsyncThunk(
  `${config.name}/getUsersList`,
  async ({ params, body }: any) => {
    return Client.get(API_GET_USERS, { params: { ...params, ...body } });
  }
);

export const getRoles: any = createAsyncThunk(
  `${config.name}/getRoles`,
  async () => {
    return Client.get(API_GET_ROLES);
  }
);

export const createUser: any = createAsyncThunk(
  `${config.name}/createUser`,
  async (body: any) => {
    return Client.post(API_CREATE_USER, body);
  }
);

export const updateUserById: any = createAsyncThunk(
  `${config.name}/updateUser`,
  async ({ userId, body }: { userId: string; body: any }) => {
    return Client.put(API_UPDATE_USER + `${userId}`, body);
  }
);

export const deleteUser: any = createAsyncThunk(
  `${config.name}/deleteUser`,
  async (userId: string) => {
    return Client.delete(API_DELETE_USER + `${userId}`);
  }
);

export const userManagementReducer = createSlice({
  name: config.name,
  initialState: {
    loadingUsers: false as any,
    userList: [] as any,
    roleList: [] as any,
    pagination: { page: 0, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {
    resetUsers: (state) => {
      state.loadingUsers = false;
      state.userList = [] as any;
      state.roleList = [] as any;
      state.pagination = { page: 0, limit: TABLE_ROWS_COUNT, total: 0 };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getUsersList.pending, (state) => {
        state.loadingUsers = true;
        state.userList = [] as any;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.loadingUsers = false;
        state.userList = action?.payload?.data?.data as any;
        state.pagination = {
          page: action?.payload?.data?.page,
          limit: action?.payload?.data?.limit,
          total: action?.payload?.data?.total,
        };
      })
      .addCase(getUsersList.rejected, (state) => {
        state.loadingUsers = false;
        state.userList = [] as any;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.roleList = action?.payload?.data?.data || [];
      });
  },
});

export const { resetUsers } = userManagementReducer.actions;
export default userManagementReducer.reducer;
